import { useState } from "react";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  Input,
  List,
  Flex,
  Checkbox,
  Text,
  Icon,
  Button
} from "@theorgchartdev/storybook";
import CentralizedModalContainer from "../../../../../Utils/CentralizedModalContainer/CentralizedModalContainer";
import { BuildWhitelistOptions } from "../AuthorizationUtils";
import { UpdateUser } from "../../ManageUsers/Utils";
import { appstr } from "@coreapp/utils/appstr";

export const LinkUserModal = ({ show, user, onClose }) => {
  const [editingUser, setEditingUser] = useState(user);
  const [editWhitelist, setEditWhitelist] = useState(false);
  const [whitelistIdx, setWhitelistIdx] = useState(null);
  const [whitelistText, setWhitelistText] = useState("");
  const [changedKeys, setChangedKeys] = useState([]);

  const UpdateChangedKeys = key => {
    if (!changedKeys.includes(key)) setChangedKeys([...changedKeys, key]);
  };

  const HandleDomainAction = (key, idx) => {
    switch (key) {
      case "edit":
        setEditWhitelist(true);
        setWhitelistIdx(idx);
        setWhitelistText(editingUser.domainWhitelist[idx]);
        break;
      case "delete":
        let whitelist = [...editingUser.domainWhitelist];
        whitelist.splice(idx, 1);
        setEditingUser(prevState => ({
          ...prevState,
          domainWhitelist: [...whitelist]
        }));
        UpdateChangedKeys("domainWhitelist");
        break;
    }
  };

  const SaveWhiteListEntry = () => {
    if (whitelistIdx) {
      let whitelist = editingUser.domainWhitelist;
      whitelist[whitelistIdx] = whitelistText;
      setEditingUser(prevState => ({ ...prevState, domainWhitelist: whitelist }));
    } else {
      setEditingUser(prevState => ({
        ...prevState,
        domainWhitelist: [...prevState.domainWhitelist, whitelistText]
      }));
    }
    UpdateChangedKeys("domainWhitelist");
    setEditWhitelist(false);
    setWhitelistIdx(null);
    setWhitelistText("");
  };

  const SaveUserSettings = async () => {
    const userData = {};
    userData["user"] = changedKeys.map(key => ({ [key]: editingUser[key] }));
    userData["userID"] = editingUser.username;
    const { result } = await UpdateUser({ theData: userData });

    if (result) onClose(true);
  };

  const HandlePublicAccessToggle = () => {
    setEditingUser(prevState => ({ ...prevState, ignoreref: !prevState.ignoreref }));
    UpdateChangedKeys("ignoreref");
  };

  const HandleTextInput = value => {
    setWhitelistText(value);
  };

  return (
    <CentralizedModalContainer show={show}>
      <Modal
        id="link-user-modal"
        show={show}
        centerScreen={true}
        fullScreen={false}
        customStyle={{ padding: 0, width: "640px" }}
      >
        <DialogTitle>
          <span className={"ocn-explorer-icon-label"}>
            <Icon size={"medium"} name={"link"} />
            {appstr("Configure Link Access")}
          </span>
        </DialogTitle>

        <DialogContent>
          <Flex direction={"column"} gap={"8px"} padding={"16px 0px 0px 0px"}>
            <Text>{appstr("Configure whitelist domains for restricted link access")}</Text>
            <Text>{appstr("User") + ": " + user.email}</Text>
            <Checkbox
              key={"link-user-chkbox"}
              id={"link-user-chkbox"}
              data-testid="account-settings-authorization-link-user-public-access-checkbox"
              size="medium"
              label={appstr("Allow Public Access")}
              checked={editingUser?.ignoreref}
              onToggle={() => HandlePublicAccessToggle()}
            />
            <Flex direction={"row"} justifyContent={"space-between"}>
              <Text modifier={"bold"}>{appstr("Allowed Referrer Domains")}</Text>
              <Button
                modifier={"secondary"}
                iconOnly={true}
                iconProps={{ name: "plus" }}
                onClick={() => setEditWhitelist(true)}
                dataTestId="account-settings-authorization-link-user-add-whitelist-btn"
              />
            </Flex>
            <List
              enableVirtualization={false}
              options={BuildWhitelistOptions(editingUser, HandleDomainAction)}
              listWidth="fill"
              optionSize={"large"}
              showCheck={false}
              value={null}
            />
            {editWhitelist && (
              <Flex direction={"row"} justifyContent={"space-between"} alignItems={"end"}>
                <div style={{ width: "75%" }}>
                  <Input
                    label={
                      whitelistIdx
                        ? appstr("Edit Whitelist Domain")
                        : appstr("Add Whitelist Domain")
                    }
                    value={whitelistText}
                    type={"text"}
                    size={"medium"}
                    onChange={e => HandleTextInput(e.target.value)}
                    dataTestId="account-settings-authorization-link-user-whitelist-input"
                  />
                </div>
                <Flex gap={"24px"}>
                  <div
                    style={{ cursor: "pointer" }}
                    data-testid="account-settings-authorization-link-user-whitelist-discard-btn"
                  >
                    <Text
                      size={"small"}
                      modifier={"medium"}
                      colorModifier={"theme"}
                      onClick={() => {
                        setEditWhitelist(false);
                        setWhitelistIdx(null);
                        setWhitelistText("");
                        setEditingUser(editingUser);
                      }}
                    >
                      {appstr("Discard")}
                    </Text>
                  </div>
                  <div
                    style={{ cursor: "pointer" }}
                    data-testid="account-settings-authorization-link-user-whitelist-save-btn"
                  >
                    <Text
                      size={"small"}
                      modifier={"medium"}
                      colorModifier={"theme"}
                      onClick={() => SaveWhiteListEntry()}
                    >
                      {appstr("Save")}
                    </Text>
                  </div>
                </Flex>
              </Flex>
            )}
          </Flex>
        </DialogContent>

        <DialogActions divider={true}>
          <DialogActions.Tertiary
            onClick={() => onClose(false)}
            dataTestId="account-settings-authorization-link-user-cancel-btn"
          >
            {appstr("Cancel")}
          </DialogActions.Tertiary>
          <DialogActions.Primary
            onClick={() => SaveUserSettings()}
            dataTestId="account-settings-authorization-link-user-save-btn"
          >
            {appstr("Save")}
          </DialogActions.Primary>
        </DialogActions>
      </Modal>
    </CentralizedModalContainer>
  );
};
